import i18n from 'i18n';

export const BLOCKED_SCOPE_LABEL = 'Failed to lock/unlock resource from array';
export const BLOCKED_SCOPE_CODE = 'LOCK001';

export const GENERIC_ERROR_MESSAGES: UserFacingErrorMessages = {
  actionHeading: '',
  bulletPoints: [],
  description: i18n.t('Something_went_wrong._Please_try_again.'),
  supportMessage: i18n.t('If_the_error_persists,_please_reach_out_to'),
  title: i18n.t('Error_summary'),
};

export const CONVERSION_ERROR_MESSAGES: UserFacingErrorMessages = {
  actionHeading: i18n.t('Please_check_the_following_and_try_again:'),
  bulletPoints: [
    i18n.t('File_is_less_than_10_MB'),
    i18n.t('No_special_characters_in_the_file_name_(&,$,@,_etc.)'),
    i18n.t('Make_sure_your_file_is_not_corrupted_or_protected'),
  ],
  description: i18n.t('An_error_occurred_while_uploading_this_file.'),
  supportMessage: i18n.t('If_the_error_persists,_please_reach_out_to'),
  title: i18n.t('Converting_File_Error_Summary'),
};

export const NORMALIZATION_ERROR_MESSAGES: UserFacingErrorMessages = {
  actionHeading: i18n.t('Please_check_the_following_and_try_again:'),
  bulletPoints: [
    i18n.t('Column_positions_&_header_names_are_correct'),
    i18n.t(
      'Data_in_cells_are_correctly_formatted_(currency,_date_formats,_etc.)',
    ),
    i18n.t('File_contains_all_required_data_points'),
  ],
  description: i18n.t(
    'The_file_uploaded_doesn’t_follow_the_format_defined_for_your_company.',
  ),
  supportMessage: i18n.t('If_the_error_persists,_please_reach_out_to'),
  title: i18n.t('Processing_File_Error_Summary'),
};

export const PERSISTENCE_ERROR_MESSAGES: UserFacingErrorMessages = {
  actionHeading: '',
  bulletPoints: [],
  description: i18n.t('An_error_occurred_while_uploading_this_file.'),
  supportMessage: i18n.t('Please_reach_out_to'),
  title: i18n.t('Saving_File_Error_Summary'),
};

export const CLONE_LISTING_ERROR_MESSAGES: UserFacingErrorMessages = {
  actionHeading: '',
  bulletPoints: [],
  description: i18n.t('An_error_occurred_while_cloning_this_listing.'),
  supportMessage: '',
  title: i18n.t("We're_unable_to_clone_your_offer."),
};

export const WITHDRAW_LISTING_ERROR_MESSAGES: UserFacingErrorMessages = {
  actionHeading: '',
  bulletPoints: [],
  description: i18n.t('An_error_occurred_while_withdrawing_this_listing.'),
  supportMessage: '',
  title: i18n.t("We're_unable_to_withdraw_your_offer."),
};

export type UserFacingErrorMessages = {
  actionHeading: string;
  bulletPoints: string[];
  description: string;
  supportMessage: string;
  title: string;
};
